module.exports = __webpack_public_path__ + "cd4399ef1e1c3abcd3c6866137e81c05.svg";